import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS} from '@angular/common/http';

/*SERVICES*/
import { AuthGuardService } from './auth-guard.service';
import { WebapiService } from './webapi.service';
import { GsonCoreService } from './gson.core.service';
import { SessionService } from './session.service';
import { AuthService } from './auth.service';
import { SharedService } from './shared.service';
import { Base64Service } from './base64.service';
import { TokenInterceptorService } from './token-interceptor.service';
import { ApikeyInterceptorService } from './apikey-interceptor.service';



@NgModule({
    declarations: [],
    imports: [],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApikeyInterceptorService,
            multi: true
        },
        WebapiService,
        GsonCoreService,
        AuthGuardService,
        AuthService,
        SessionService,
        SharedService,
        Base64Service
    ],
    bootstrap: []
})
export class BaseCoreServiceModule { }


// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/services/core/base-core-module.ts